import { EnumDescriptions } from '@/app/shared/utils';
import { i18n } from '@/plugins';

export enum Month {
  Jan = 1,
  Feb = 2,
  Mar = 3,
  May = 4,
  Apr = 5,
  Jun = 6,
  Jul = 7,
  Aug = 8,
  Sep = 9,
  Oct = 10,
  Nov = 11,
  Dec = 12,
}
EnumDescriptions.setDescriptions(Month, [
  i18n.t('enums.month.jan'),
  i18n.t('enums.month.feb'),
  i18n.t('enums.month.mar'),
  i18n.t('enums.month.may'),
  i18n.t('enums.month.apr'),
  i18n.t('enums.month.jun'),
  i18n.t('enums.month.jul'),
  i18n.t('enums.month.aug'),
  i18n.t('enums.month.sep'),
  i18n.t('enums.month.oct'),
  i18n.t('enums.month.nov'),
  i18n.t('enums.month.dec'),
]);
